const LogoSVG = () => {
  return (
    <>
      <svg
        id="logo_anim"
        width="100%"
        height="100%"
        viewBox="0 0 512 512"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="#e42529ff">
          <path
            fill="#e42529"
            opacity="1.00"
            d=" M 200.63 0.00 L 201.71 0.00 C 204.30 1.24 206.93 2.39 209.58 3.48 C 233.26 13.71 252.83 32.93 263.73 56.28 C 274.13 78.18 276.80 103.64 271.13 127.22 C 262.92 159.08 254.85 190.97 246.64 222.82 C 231.66 227.37 217.44 234.48 204.99 243.99 C 183.07 260.74 166.25 284.11 157.12 310.12 C 157.46 305.76 158.16 301.45 158.78 297.13 C 172.36 199.79 185.97 102.46 199.55 5.13 C 199.82 3.40 200.22 1.70 200.63 0.00 Z"
            className="svg-elem-1"
          ></path>
        </g>
        <g id="#1767afff">
          <path
            fill="#1767af"
            opacity="1.00"
            d=" M 140.51 36.67 C 143.44 36.35 146.29 37.24 149.12 37.85 C 159.13 40.16 168.76 44.01 177.73 49.00 C 167.99 119.13 157.96 189.22 148.47 259.38 C 147.18 235.58 146.75 211.73 145.73 187.92 C 144.07 137.50 142.01 87.09 140.51 36.67 Z"
            className="svg-elem-2"
          ></path>
        </g>
        <g id="#119b49ff">
          <path
            fill="#119b49"
            opacity="1.00"
            d=" M 84.78 83.89 C 86.14 83.46 87.54 83.07 88.98 83.15 C 101.86 83.20 114.68 85.71 126.71 90.28 C 129.14 158.83 131.57 227.38 134.00 295.93 C 134.18 302.73 134.76 309.54 134.47 316.35 C 125.66 272.83 116.05 229.47 106.94 186.02 C 100.06 153.69 93.16 121.36 86.30 89.02 C 85.87 87.29 85.30 85.59 84.78 83.89 Z"
            className="svg-elem-3"
          ></path>
        </g>
        <g id="#efb31bff">
          <path
            fill="#efb31b"
            opacity="1.00"
            d=" M 242.29 241.13 C 257.87 235.60 274.46 232.88 291.00 233.18 C 320.29 233.53 349.29 243.70 372.58 261.42 C 395.23 278.46 412.22 302.67 420.97 329.60 C 398.29 334.66 375.55 339.44 352.86 344.45 C 342.12 319.17 315.52 301.68 288.00 302.28 C 270.51 302.39 253.18 309.37 240.54 321.46 C 229.29 332.10 221.71 346.55 219.43 361.87 C 216.84 378.52 220.60 396.04 229.69 410.22 C 243.10 431.60 268.77 444.51 293.95 442.32 C 312.57 440.94 330.45 431.76 342.34 417.34 C 353.03 404.58 358.90 387.94 358.66 371.30 C 381.30 366.32 403.97 361.50 426.61 356.52 C 428.58 367.19 428.43 378.17 426.62 388.86 C 421.76 433.01 394.10 473.83 354.96 494.81 C 336.41 505.16 315.42 510.10 294.40 512.00 L 282.71 512.00 C 273.08 510.83 263.39 509.80 254.00 507.28 C 235.04 502.40 217.17 493.42 201.89 481.21 C 180.33 464.04 164.08 440.31 155.97 413.97 C 148.40 389.98 147.76 364.01 153.28 339.52 C 158.04 319.69 167.32 300.96 180.20 285.15 C 196.39 265.17 218.37 250.30 242.29 241.13 Z"
            className="svg-elem-4"
            id="svg-elem-4"
          ></path>
        </g>
      </svg>
    </>
  );
};
export default LogoSVG;
